import { LitElement, html, css } from 'lit'

export class IconBase extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: var(--icon-width, 1em);
      height: var(--icon-height, auto);
      position: relative;
      top: var(--icon-offset, 2px);
    }
    svg {
      stroke: var(--icon-stroke-color, currentColor);
      stroke-width: var(--icon-stroke-width, 1.5);
      fill: none;
      width: 100%;
      height: auto;
    }
  `
}